
<template>
  <div class="vld-parent">

    <loading :active.sync="isLoading" 
    :can-cancel="true" 
    :is-full-page="fullPage"></loading>

    <div class="row">
      <div class="col-lg-8 style-paper text-center">
        <h4>Schedules</h4>
        <div class="row">
          <div class="col-lg-4 col-sm-4 text-left">
            <a @click="makeCurrent" class="btn btn-success make-current-btn-mobile-size">Make Current</a>
          </div>
          <div class="col-lg-4 col-sm-4">
            <el-select size="large" placeholder="" class="schedule-select" v-model="selects.simple" @change="selectSchedule()">
              <el-option v-for="option in schedulesData"
                          :value="option.entity_id"
                          :label="option.name"
                          :key="option.entity_id">
              </el-option>
              <el-option value="-1" label="Add New..." key="-1"/>
            </el-select>
          </div>
          <div class="col-lg-4 col-sm-4 text-right">
            <a  @click="deleteSchedule" class="btn btn-danger delete-btn-mobile-size">Delete</a>
          </div>
        </div>
        <hr>
        <div v-if="selects.simple == -1" class="col-lg-12 schedules-table-content">
          <h4 class="card-title">Add Schedule</h4>
         
        </div>
        
        <div class="col-lg-12 schedules-table-content">
          <table v-if="schedulesData.length != 0" cellspacing="0" cellpadding="0" border="0" class="el-table mx-auto">
            <thead class="has-gutter">
              <tr class="text-primary" @click="selectAllActivities">
                <th class="text-center" v-for="column in columns" :key="column.id">{{column}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(activity, index) in schedulesData[currentIndex].activities"  :key="activity.id" @click="selectActivity(index)">
                <td class="text-center">{{activity.name}}</td>
                <td class="text-center" v-if="activity.frequency==7">Daily</td>
                <td class="text-center" v-if="activity.frequency==1">Weekly</td>
                <td class="text-center"><input class="form-control centered" style="width: 100px;" v-model="activity.hours" type="number" @change="updateActivityHours"></td>
                <td style="width: 18%; height:50px;" class="text-center">
                  <div class="cell">
                    <button @click="deleteActivity(index)" type="button" class="btn btn-icon btn-danger btn-sm" v-show="activity.deleteable">
                     <i class="fa fa-times"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr class="last-row">
                <td>
                  <div class="input-field col-lg-10 pl-0 centered" style="width: 200px">
                    <input class="form-control" placeholder="Activity" ref="activity"
                           @input="changeActivity()" v-model="input.activity" id="activity" type="text">
                  </div>
                  <div class="text-danger invalid-feedback" v-show="validActivityName" style="display: block;">
                    Invaild name.
                  </div>
                </td>
                <td>
                  <div class="input-field col-lg-10 pl-0 centered" style="width: 100px;">
                    <el-select style="height: 52px" size="small" v-model="input.frequency">
                      <el-option value="7" label="Daily"></el-option>
                      <el-option value="1" label="Weekly"></el-option>
                    </el-select>
                  </div>
                </td>
                <td>
                  <div class="input-field col-lg-10 pl-0 centered" style="width: 100px;">
                    <input class="form-control"  placeholder="Hours" v-model="input.hours" id="hours" type="number">
                  </div>
                </td>
                <td class="text-right">
                  <div class="cell">
                    <a  @click="addActivity" class="btn btn-success add-btn"><i class="fa fa-plus" style="margin-right: 5px;"/> Add Activity</a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-lg-4 row schedules-data-table">
        <div class="col-lg-11 style-paper mx-auto">
          <div style="text-align: center;"><h4>Time and Earnings</h4></div>
          <table cellspacing="0" cellpadding="0" border="0" class="el-table ">
            <tbody>
              <tr>
                <td><strong>Hours Allocated:</strong></td>
                <td v-if="schedulesData.length != 0">{{schedulesData[currentIndex].allocated}}</td>
              </tr>
              <tr>
                <td><strong>Hours Available:</strong></td>
                <td v-if="schedulesData.length != 0">{{schedulesData[currentIndex].available}}</td>
              </tr>
              <tr>
                <td>
                  <strong>Effective Rate <sup>1</sup> :</strong>
                </td>
                <td>${{hoursRate.toFixed(2)}}</td>
              </tr>
              <tr>
                <td>
                  <strong>Weekly Potential:</strong>
                </td>
                <td v-if="schedulesData.length != 0">${{(Math.round(hoursRate * schedulesData[currentIndex].available)).toLocaleString()}}
                </td>
              </tr>
            <tr class="last-row">
              <td colspan="2">
                <span style="font-size: 12px"><sup>1</sup> This value comes from the Income screen data</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

<!-- modal -->
    <div v-if="showModal" class="modal-backdrop in"></div>
    <div v-if="showModal" class="modal ">
    <div class="modal-dialog">
        <div class="modal-content">
            
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="hideDialog">&times;</button>
                <h4 class="modal-title text-center">Add Schedule</h4>
              <fg-input  placeholder="Name" type="schedule" name="schedule" @input="changeScheduleName()" v-model="input.schedule" ></fg-input>
              <div class="text-danger invalid-feedback" style="display: block;" v-show="validScheduleName">
                "Current" is a reserved name, please choose another.
              </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary " @click="addSchedule" :disabled="validScheduleName">Submit</button>
            </div>
        </div>
      </div>
    </div>

    <modal :show.sync="showHowTo"
           footer-classes="justify-content-center"
           type="notice">
      <h5 slot="header" class="modal-title">How Do You Use This Screen?</h5>
      <template>
        <div class="instruction">
          <div class="row">
            <div class="col-md-12">
              <strong>Edit your current schedule</strong>
              <p class="description">
                We created a basic schedule for you which includes sleeping, eating, and exercising - like every
                schedule should.  You can set the values to 0, if you like, but they can't be removed.  You can
                enter any other activities you want, and we'll use all the remaining time to calculate your potential
                earnings.
              </p>
            </div>
          </div>
        </div>
        <div v-if="this.showIncomeMessage" class="instruction">
          <div class="row">
            <div class="col-md-12">
              <strong>But we'll need your rate first</strong>
              <p class="description">
                You maverick! It looks like you came here before completing the Income screen.  That's fine, but if we
                don't know your rate your Weekly Potential will look pretty uninspiring.
              </p>
            </div>
          </div>
        </div>
      </template>
      <div slot="footer" class="justify-content-center">
        <p-button type="info" round @click.native="showHowTo = false">Got it!</p-button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { AmplifyEventBus } from "aws-amplify-vue";
import { Auth, Analytics } from "aws-amplify";
import {
  getSchedulesAPI,
  updateSchedulesAPI,
  addSchedulesAPI,
  deleteSchedulesAPI,
  getLatestMonthlyIncomeAPI
} from "./../../api/api";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapActions } from 'vuex';
import {
  Select,
  Option
} from "element-ui";
import Modal from "../UIComponents/Modal"

export default {
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    Modal
  },

  created() {
    this.setNavbarTitle('Time');
  },

  async mounted() {
    await this.getSchedules();
    if (this.schedulesData.length == 1 && this.schedulesData[0].available == 92) {
      this.showHowTo = true;
    }
    getLatestMonthlyIncomeAPI().then(data => {
      if (!data.hasOwnProperty("error")) {
        let effective_rate = data.total_income / data.hours;
        this.hoursRate = effective_rate;
      } else {
        this.showIncomeMessage = true;
      }
    })
  },

  data() {
    return {
      //for modal input
      showModal: false,
      scheduleName: "",

      //loading
      isLoading: false,
      fullPage: true,

      showHowTo: false,
      showIncomeMessage: false,

      //data
      schedulesData: [],
      hoursRate: 0,

      activeActivities: [],

      selects: {
        simple: ""
      },

      currentIndex: 0,
      columns: ["Activity", "Frequency", "Hours", ""],

      input: {
        activity: "",
        frequency: "7",
        hours: "",
        schedule: ""
      },
      editInput: {
        activity: "",
        frequency: "",
        hours: ""
      },
      modelValidations: {
        schedule: {
          required: true,
          is_not: "current"
        }
      },
      validScheduleName: false,
      validActivityName: false
    };
  },

  computed: {
    selectedAllActivities: {
      get() {
        return this.activeActivities.length === this.schedulesData[this.currentIndex].activities.length;
      },
      set(val) {
        if (val) {
          this.activeActivities = this.schedulesData[this.currentIndex].activities.map((item, i) => i);
        } else {
          this.activeActivities = [];
        }
      }
    }
  },

  methods: {
    ...mapActions('UI', ['setNavbarTitle']),

    selectAllActivities() {
      this.selectedAllActivities = !this.selectedAllActivities;
    },

    selectActivity(id) {
      if (this.activeActivities.includes(id)) {
        this.activeActivities.splice(this.activeActivities.indexOf(id), 1);
      } else {
        this.activeActivities.push(id);
      }
    },
    
    async getSchedules() {
      this.isLoading = true;
      this.schedulesData = await getSchedulesAPI();
      if(this.schedulesData == "") {
        this.schedulesData = []
      }
      this.currentIndex = 0;
      for (var i = 0; i < this.schedulesData.length; i++) {
        let schedule = this.schedulesData[i];
        for (var j = 0; j < schedule.activities.length; j++) {
          let activity = schedule.activities[j];
          if (
            activity.name.toLowerCase() == "sleep" ||
            activity.name.toLowerCase() == "eat" ||
            activity.name.toLowerCase() == "exercise"
          ) {
            activity.deleteable = false;
          } else {
            activity.deleteable = true;
          }
        }
        if (schedule.is_current == true) {
          this.currentIndex = i;
          this.selects.simple = schedule.entity_id;
        }
      }
      this.isLoading = false;
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      this.$validator.validateAll().then(isValid => {
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },

    makeCurrent: function() {
      for (var i = 0; i < this.schedulesData.length; i++) {
        let schedule = this.schedulesData[i];
        if (schedule.is_current) {
          schedule.is_current = false;
          schedule.name = "Old";
          updateSchedulesAPI(schedule);
          break;
        }
      }

      let scheduleData = this.schedulesData[this.currentIndex]

      scheduleData.name = "Current";
      scheduleData.is_current = true;
      updateSchedulesAPI(scheduleData);
      Analytics.record({ name: "plan time make current" });
    },

    changeActivity: function() {
      if (
        this.input.activity.toLowerCase() != "sleep" &&
        this.input.activity != "" &&
        this.input.activity.toLowerCase() != "eat" &&
        this.input.activity.toLowerCase() != "exercise"
      ) {
        this.validActivityName = false;
      } else {
        this.validActivityName = true;
      }
    },

    changeScheduleName: function() {
      if (
        this.input.schedule.toLowerCase() != "current" &&
        this.input.schedule != ""
      ) {
        this.validScheduleName = false;
      } else {
        this.validScheduleName = true;
      }
    },

    addActivity: function() {
      if (this.input.activity === "") {
        this.$refs.activity.focus();
        return;
      }

      if (this.input.frequency === "") {
        this.$refs.frequency.focus();
        return;
      }

      if (this.input.hours === "") {
        this.$refs.hours.focus();
        return;
      }

      let scheduleData = this.schedulesData[this.currentIndex]
      scheduleData.activities.push({
        name: this.input.activity,
        frequency: this.input.frequency,
        hours: this.input.hours,
        deleteable: true
      });

      this.updateScheduleAndSave(scheduleData)

      this.input.name = "";
      this.input.hours = "";

      this.$refs.activity.focus();
      Analytics.record({ name: "plan time add schedule item" });
    },

    updateActivityHours: function() {
      let scheduleData = this.schedulesData[this.currentIndex];
      this.updateScheduleAndSave(scheduleData)
    },

    updateScheduleAndSave(scheduleData) {
      let allocated_hours = 0;

      for (let i=0;i < scheduleData.activities.length;i++) {
        allocated_hours = allocated_hours + (scheduleData.activities[i].hours * scheduleData.activities[i].frequency);
      }

      scheduleData.allocated = allocated_hours;
      scheduleData.available = 168 - scheduleData.allocated;

      updateSchedulesAPI(scheduleData).then();
    },

    hideDialog () {
      this.showModal = false
    },

    addSchedule () {
      if (this.input.schedule == '') {
        return
      }
      Analytics.record({ name: "plan time add schedule" });
      let params = {
        name: this.input.schedule,
        is_current: false,
        allocated: 76,
        available: 92,
        activities: [
          { name: "Sleep", frequency: 7, hours: 8, deleteable: false },
          { name: "Eat", frequency: 7, hours: 2, deleteable: false },
          { name: "Exercise", frequency: 1, hours: 6, deleteable: false }
        ]
      };

      this.showModal = false;

      addSchedulesAPI(params).then(data => {
        this.schedulesData.push(data)
        this.selects.simple = data.entity_id
        this.currentIndex = this.schedulesData.length - 1;
      });
    },

    deleteActivity: function(index) {
      Analytics.record({ name: "plan time delete schedule item" });
      let scheduleData = this.schedulesData[this.currentIndex];
      scheduleData.activities.splice(index, 1);
      this.updateScheduleAndSave(scheduleData);
    },

    deleteSchedule: function() {
      Analytics.record({ name: "plan time delete schedule" });
      let scheduleData = this.schedulesData[this.currentIndex];
      if (!scheduleData.is_current) {
        this.isLoading = true;
        deleteSchedulesAPI(scheduleData.entity_id).then(() => {
          this.getSchedules();
        })
      }
    },

    selectSchedule: function() {
      var context = this;
      Analytics.record({ name: "plan time change schedule" });

      this.activeActivities = [];
      Vue.nextTick(function() {
          var selectIndex = -1
          for (var i = 0; i < context.schedulesData.length; i++) {
            let schedule = context.schedulesData[i];
            if (schedule.entity_id == context.selects.simple) {
              context.currentIndex = i;
              selectIndex = i;
              break;
            }
          }
          if (selectIndex == -1) {
            context.showModal = true
            context.currentIndex = 0

        }
      });
    }
  }
};
</script>

<style>
.el-table .last-row td {
  border-bottom: none;
}
.modal-active{
	display:block;
}
.modal-backdrop.in {
    filter: alpha(opacity=50);
    opacity: .5;
}
.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: block;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    outline: 0;
}

  .style-paper {
    -moz-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
    -ms-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
    -o-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
    -webkit-transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
    background-color: #fff;
    border: 0;
    border-radius: 3px;
    box-shadow: 0 6px 10px -4px rgba(0,0,0,.15);
    color: #252422;
    margin: 0px;
    margin-bottom: 20px;
    position: relative;
    transition: transform .3s cubic-bezier(.34,2,.6,1),box-shadow .2s ease;
}
  .el-input--suffix .el-input__inner {
    margin-top:10px;
  }
  .el-select .el-input .el-select__caret{
    margin-top:5px;
  }
  .el-input--suffix .el-input__inner:hover {
    background-color: #51cbce;
  }
  .schedules-table-content {
    margin-top: 30px;
  }
  .add-btn {
    color: white !important;
  }
  .schedules-data-table {
    height: 100%;
  }
  .schedule-select {
    width: 100%;
  }
  .btn-lightgreen {
    background-color: #6bd098;
  }
  .el-select .el-input:hover .el-input__icon, .el-select .el-input:hover input {
    background-color: #51cbce !important;
  }
  .el-select .el-input:hover .el-input__icon, .el-select .el-input:hover {
    background-color: transparent !important;

  }
  
  @media (max-width: 575px){
    .make-current-btn-mobile-size {
      width: 100%;
    }
    .delete-btn-mobile-size {
      width: 100%;
    }
  }
</style>

<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
.card1 {
  background-color: #ffffff;
}
  .centered {
    text-align: center;
    margin: auto;
  }
</style>
